define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var $ = require('j');
    var i18n = require('i18n');
    var userValidationConfig = require('modules/user/user.validation.config');
    var variablesConfig = require('config');
    var mathUtil = require('util/math.util');
    var globalConfig = require('config');
    var utils = require('utils');

    module.exports = function() {
        var userCfg = userValidationConfig();

        var nameRegExp = /^([A-Za-z])([A-Za-z,.\s]*)$/;

        var isZeroAndIsInput = function(value, isInputType) {
            var isInvalidValue = !value && value !== 0;
            var isZeroValue = value === 0 && isInputType;
            return !(isInvalidValue || isZeroValue);
        };

        var isZeroAndIsDropdown = function(value, isInputType) {
            return value === 0 && !isInputType;
        };

        var isFitLimitAmount = {
            'session': function(data, isInputType) {
                var value = data.session;
                // deposit limit has editable dropdown type
                // 'isInputType' param use for loss/bet limits
                var isDepositLimit = _.isUndefined(isInputType);

                if (!isDepositLimit && !isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (!isDepositLimit && isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day < value) {
                    return false;
                }
                if (data.week && data.week < value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }

                return true;
            },
            'day': function(data, isInputType) {
                var value = data.day;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.week && data.week < value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },
            'week': function(data, isInputType) {
                var value = data.week;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day > value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },
            'month': function(data, isInputType) {
                var value = data.month;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day > value) {
                    return false;
                }
                if (data.week && data.week > value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            }
        };

        var getCustomFieldValidationConfig = function(fieldName, options) {
            return {
                required: true,
                length: {
                    min: options.length.min,
                    max: options.length.max,
                    message: i18n.t('playtech.mobile.registration.' + fieldName + '.tooltip.length')
                },
                regexp: {
                    regexp: options.regexp,
                    message: i18n.t('playtech.mobile.registration.' + fieldName + '.tooltip.regexp')
                }
            };
        };

        var checkPesel = function($inputs, config, form, state, event, data) {
            // although reg builder won't allow to do this we'll make this fail-proof check

            var pesel = $inputs.val();

            if (!/^\d{11}$/.test(pesel)) {
                return false;
            }

            var peselSplits = pesel
                .split(/(\w{2})(\w{2})(\w{2})(\w{4})(\w)/)
                .filter(function(part) {
                    return part !== '';
                })
                .map(function(part) {
                    return Number(part);
                });
            var peselRR = peselSplits[0];
            var peselMM = peselSplits[1];
            var peselDD = peselSplits[2];
            var peselK = peselSplits[4];

            var checkPeselCheckSum = function() {
                var weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                var checkSum = pesel
                    .split('')
                    .slice(0, 10)
                    .map(function(peselDigit, index) {
                        return Number(peselDigit) * weights[index];
                    })
                    .reduce(function(result, num) {
                        return result + num;
                    }, 0);
                checkSum = checkSum % 10 === 0 ? 0 : 10 - checkSum % 10;

                return peselK === checkSum;
            };

            if (form?.options?.isPeselAndDate && form?.options?.isRegistrationForm) {
                return checkPeselCheckSum();
            }

            if (!data.dateOfBirth) {
                return false;
            }

            var dateSplits = data.dateOfBirth.split('-');
            var year = Number(dateSplits[0]);
            var month = Number(dateSplits[1]);
            var day = Number(dateSplits[2]);

            var checkPeselYear = function() {
                return peselRR === year % 100;
            };

            var checkPeselMonth = function() {
                var shift;

                if (year >= 1900 && year <= 1999) {
                    shift = 0;
                } else if (year >= 1800 && year <= 1899) {
                    shift = 80;
                } else if (year >= 2000 && year <= 2099) {
                    shift = 20;
                } else if (year >= 2100 && year <= 2199) {
                    shift = 40;
                } else if (year >= 2200 && year <= 2299) {
                    shift = 60;
                }

                return peselMM === month + shift;
            };

            var checkPeselDay = function() {
                return peselDD === day;
            };

            return checkPeselYear()
                && checkPeselMonth()
                && checkPeselDay()
                && checkPeselCheckSum();
        };

        userCfg.firstname.regexp.regexp = nameRegExp;
        userCfg.lastname.regexp.regexp = nameRegExp;
        userCfg.userName = _.extend({}, userCfg.userName, {
            length: {
                min: 6,
                max: 16,
                message: i18n.t('playtech.mobile.system.user.tooltip.userName.length')
            },
            regexp: {
                regexp: /^[A-Za-z0-9]+$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.userName.regexp')
            }
        });
        userCfg.coupon = {
            length: {
                min: 1,
                max: 10,
                message: i18n.t('playtech.mobile.system.user.tooltip.coupon.length')
            },
            regexp: {
                regexp: /^[A-Za-z0-9]+$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.coupon.regexp')
            }
        };

        userCfg.limit.required = false;

        userCfg.limit.length = {
            min: 1,
            max: 10,
            message: i18n.t('playtech.mobile.system.user.tooltip.limit.regexp')
        };

        userCfg.limit.regexp = {
            regexp: /^[0-9]+$/,
            message: i18n.t('playtech.mobile.system.user.tooltip.limit.regexp')
        };

        userCfg.limit.fn = {
            fn: function($inputs, config, form) {
                var value = $inputs.val();

                if (value && !/^[0-9]+$/.test(value)) {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.limit.regexp');
                    return false;
                }
                var fieldsets = {
                    deposit: [
                        'sessionlimits',
                        'daydepositlimit',
                        'weekdepositlimit',
                        'monthdepositlimit'
                    ],
                    loss: [
                        'sessionlosslimit',
                        'daylosslimit',
                        'weeklosslimit',
                        'monthlosslimit'
                    ],
                    bet: [
                        'sessionbetlimit',
                        'daybetlimit',
                        'weekbetlimit',
                        'monthbetlimit'
                    ]
                };
                var fields = form.$el.find('.fn-validate');
                var fieldtypes = ['session', 'daily', 'weekly', 'monthly'];
                var checkLimits = {
                    'session': function(data) {
                        if (data.session === 0) {
                            return true;
                        }
                        if (data.daily && data.daily < data.session) {
                            return false;
                        }
                        if (data.weekly && data.weekly < data.session) {
                            return false;
                        }
                        if (data.monthly && data.monthly < data.session) {
                            return false;
                        }

                        return true;
                    },
                    'daily': function(data) {
                        if (data.daily === 0) {
                            return true;
                        }
                        if (data.weekly && data.weekly < data.daily) {
                            return false;
                        }
                        if (data.monthly && data.monthly < data.daily) {
                            return false;
                        }
                        if (data.session && data.session > data.daily) {
                            return false;
                        }

                        return true;
                    },
                    'weekly': function(data) {
                        if (data.weekly === 0) {
                            return true;
                        }
                        if (data.daily && data.daily > data.weekly) {
                            return false;
                        }
                        if (data.monthly && data.monthly < data.weekly) {
                            return false;
                        }
                        if (data.session && data.session > data.weekly) {
                            return false;
                        }

                        return true;
                    },
                    'monthly': function(data) {
                        if (data.monthly === 0) {
                            return true;
                        }
                        if (data.daily && data.daily > data.monthly) {
                            return false;
                        }
                        if (data.weekly && data.weekly > data.monthly) {
                            return false;
                        }
                        if (data.session && data.session > data.monthly) {
                            return false;
                        }

                        return true;
                    }
                };
                var data = {};

                // create data object
                _.each(fieldsets, function(fieldset, fieldsetName) {
                    var index = fieldset.indexOf($inputs[0].name);

                    if (index !== -1) {
                        data.fieldset = fieldsetName;
                        data.fieldtype = fieldtypes[index];
                        data.list = {};
                        data.fields = {};

                        _.each(fieldsets[data.fieldset], function(fieldName, idx) {
                            var $select = form.$el.find('select[name="' + fieldName + '"]');
                            var $input = form.$el.find('input[name="' + fieldName + '"]');
                            var result = Number($select.val() || $input.val());
                            result = Number.isInteger(result) ? result : undefined;

                            data.list[fieldtypes[idx]] = result;

                            _.each(fields, function(field) {
                                if ($(field).find('select[name="' + fieldName + '"]').length
                                    || $(field).find('input[name="' + fieldName + '"]').length) {
                                    data.fields[fieldtypes[idx]] = field;
                                }
                            });
                        });
                    }
                });

                // check another fields
                if (form.validationInProgress !== true) {
                    form.validationInProgress = true;

                    _.each(data.fields, function(field, fieldtype) {
                        if (data.fieldtype !== fieldtype) {
                            form.validateField($(field));
                        }
                    });

                    form.validationInProgress = false;
                }

                // check current field
                if (!checkLimits[data.fieldtype](data.list)) {
                    this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + data.fieldtype);
                    return false;
                }

                return true;
            }
        };

        userCfg = _.extend({}, userCfg, {
            cnp: getCustomFieldValidationConfig(
                'cnp',
                {
                    length: {
                        min: 13,
                        max: 13
                    },
                    regexp: /^[0-9]{13}$/
                }
            ),
            idcode: getCustomFieldValidationConfig(
                'idcode',
                {
                    length: {
                        min: 2,
                        max: 2
                    },
                    regexp: /^[a-z]{2}$/i
                }
            ),
            idnumber: getCustomFieldValidationConfig(
                'idnumber',
                {
                    length: {
                        min: 6,
                        max: 6
                    },
                    regexp: /^[0-9]{6}$/
                }
            ),
            romanian: {
                required: {
                    message: i18n.t('playtech.mobile.registration.romanian.tooltip.required')
                }
            },
            adulthood: {
                required: {
                    message: i18n.t('playtech.mobile.registration.adulthood.tooltip.required')
                }
            }

        });

        userCfg.friendEmail = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.email.required')
            },
            length: {
                min: 6,
                max: 100,
                message: i18n.t('playtech.mobile.system.user.tooltip.email.length')
            },
            email: false,
            regexp: {
                regexp: /^(?!^\.+)(?!.*\.+[^\w])(?=.*@.*\.)[\w._\-]*[0-9a-zA-Z]@(?![.\-_])([0-9a-zA-Z\-_]+\.)+[a-zA-Z]{2,}$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.registerEmail.regexp')
            }
        };

        userCfg.password.regexp.regexp = variablesConfig.get('passwordRegExp')
            || /^(?=.*[a-ząćęłńóśźż])(?=.*[A-ZĄĆĘŁŃÓŚŹŻ])(?=.*\d)[A-Za-z0-9ąćęłńóśźżĄĆĘŁŃÓŚŹŻ!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`|~{}]{8,}$/;

        userCfg.password.length = _.extend({}, userCfg.password.length, {
            min: 8,
            max: 20
        });

        userCfg.address = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.address.required')
            },
            regexp: {
                regexp: /^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż0-9.'#&\/\\\s\-]*$/,
                message: 'playtech.mobile.system.user.tooltip.address.regexp'
            },
            length: {
                min: 2,
                max: 160,
                message: 'playtech.mobile.system.user.tooltip.address.length'
            }
        };

        userCfg.iban2 = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.iban.required')
            },
            length: {
                min: 26,
                max: 26,
                message: i18n.t('playtech.mobile.system.user.tooltip.iban.length')
            },
            regexp: {
                regexp: /^[0-9]{26}$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.iban.regexp')
            }
        };

        userCfg.iban3 = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.iban.required')
            },
            length: {
                min: 26,
                max: 26,
                message: i18n.t('playtech.mobile.system.user.tooltip.iban.length')
            },
            regexp: {
                regexp: /^[0-9]{26}$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.iban.regexp')
            },
            fn: {
                fn: function($inputs) {
                    this.message = i18n.t('playtech.mobile.system.user.tooltip.iban.doubleCheck');
                    var value = $inputs.val().trim();

                    if (!value || !/\d+/.test(value)) {
                        return false;
                    }

                    var countryCodeNum = Array.from('PL')
                        .map(function(char) {
                            return char.charCodeAt(0) - 55;
                        })
                        .join('');

                    var ibanMod = value.substring(2) + countryCodeNum + value.substring(0, 2);

                    return mathUtil.modulo(ibanMod, 97) === 1;
                }
            }
        };

        userCfg.zip = _.extend({}, userCfg.zip, {
            length: {
                min: 5,
                max: 12,
                message: i18n.t('playtech.mobile.system.user.tooltip.zip.length')
            },
            fn: {
                fn: function($inputs) {
                    var zip = $inputs.val().replace(/\s/g, '');

                    $inputs.val(zip);
                    var regexp = /^[0-9]{2}-[0-9]{3}$/;
                    return regexp.test(zip);
                },
                message: i18n.t('playtech.mobile.system.user.tooltip.zip.regexp')
            }
        });

        userCfg.city = _.extend({}, userCfg.city, {
            length: {
                min: 2,
                max: 50,
                message: 'playtech.mobile.system.user.tooltip.city.length'
            },
            fn: {
                fn: function($inputs) {
                    var city = $inputs.val().trim();
                    var regexp = /^[A-Za-zĄąĆćĘęŁłŃńÓóŚśŹźŻż0-9-.,'s\s]*$/;

                    if (!regexp.test(city)) {
                        this.message = i18n.t('playtech.mobile.system.user.tooltip.city.regexp');
                        return false;
                    }

                    return true;
                },
                message: i18n.t('playtech.mobile.system.user.tooltip.city.regexp')
            }
        });

        userCfg.registerEmail = _.extend({}, userCfg.registerEmail, {
            email: false,
            regexp: {
                regexp: /^(?!^\.+)(?!.*\.+[^\w])(?=.*@.*\.)[\w._\-+]+@([0-9a-zA-Z\-_]+\.){0,2}[a-zA-Z]{2,}$/,
                message: i18n.t('playtech.mobile.system.tooltip.email')
            }
        });

        userCfg.sof = {
            required: {
                message: i18n.t('playtech.mobile.system.user.tooltip.sof.required')
            }
        };

        utils.deepExtend(userCfg, globalConfig.get('validationConfig'));

        userCfg.polandID.fn.fn = checkPesel;

        userCfg.betLimit.fn.fn = function($inputs, config, form) {
            var options = form.options.data;
            var betConfig = options.betLimitsConfig;
            var data = _.mapObject(form.data(), Number);
            var fieldName = $inputs[0].name;
            var value = Number($inputs.val());
            var viewFieldTypesMatchStr = 'daybet|weekbet|monthbet|sessionbet';
            var validationFieldTypesMatchStr = 'day|week|month|session';

            // check another fields
            var fields = form.$el.find('[data-validation-type=betLimit]');

            if (!fields.length) {
                fields = form.$el.find('.fn-bet-limit-generic');
            }

            if (!form.validationInProgress) {
                form.validationInProgress = true;

                _.each(fields, function(field) {
                    form.validateField($(field), options);
                });

                form.validationInProgress = false;
            }
            // format to {day:, week:, month:} for easy validation
            var formattedData = _.keys(data).reduce(function(memo, limitName) {
                var matched = limitName.match(viewFieldTypesMatchStr);

                if (matched) {
                    memo[matched[0].split('bet')[0]] = data[limitName];
                }

                return memo;
            }, {});

            var isAllLimitsAreEmpty = function(periods) {
                return _.every(_.pairs(periods), function(pair) {
                    return pair[1] === 0;
                });
            };

            if (!betConfig.mandatory && isAllLimitsAreEmpty(formattedData)) {
                this.message = i18n.t('playtech.mobile.system.tooltip.limits.betLimitRequired');
                return false;
            }

            if (betConfig.mandatory && value === 0) {
                this.message = i18n.t('playtech.mobile.system.tooltip.limits.allbetLimitsRequired');
                return false;
            }
            // check daily <= weekly <= monthly
            var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

            if (!isFitLimitAmount[currentLimitName](formattedData)) {
                this.message =
                    i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName + 'Limit');
                return false;
            }

            /* TODO: should be deleted when IMS is implemented */
            const hardCodedLimits = Object.assign({
                day: 10000000,
                month: 90000000
            }, window.hardCodedLimits);

            const hardCodedLimit = hardCodedLimits[currentLimitName];

            if (hardCodedLimit && value > hardCodedLimit) {
                this.message =
                    i18n.t(`playtech.mobile.system.tooltip.limits.hardcode.${currentLimitName}`, 0,
                        hardCodedLimit);

                return false;
            }
            /* TODO: end */

            if (betConfig.predefinedType === 'enabled') {
                if (betConfig.noLimitsAllowed && value === Number(betConfig.unlimitedAmount) || value
                    === 0) {
                    return true;
                }

                var allowedLimits = betConfig.predefinedLimits.map(Number);

                if (betConfig.noLimitsAllowed) {
                    allowedLimits.pop();
                }

                var min = Math.min.apply(null, allowedLimits);
                var max = Math.max.apply(null, allowedLimits);

                if (value < min || value > max) {
                    var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (betConfig.mandatory
                        ? ''
                        : '.empty');
                    this.message = i18n.t(tkEnabled, min, max);

                    return false;
                }
            }

            if (!betConfig.noLimitsAllowed && value === Number(betConfig.unlimitedAmount)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.limit.regexp');
                return false;
            }

            return true;
        };

        return userCfg;
    };
});
